module.exports = __webpack_public_path__ + "static/Uizard-announces-autodesigner-69f7c44ba600870cf8738f4553833d00.png";